const baseUrl = process.env.VUE_APP_BASE_URL || '';

export default {
    BASE_URL: baseUrl,
    GET_DEFAULT_PARAMS: {
        CUSTOMER: {
            email: '',
            lastName: '',
            loyaltyNumber: null,
            partnerIds: [],
        },
        LIMIT: 50,
        OFFSET: 0,
    },
    HEADERS: {
        GST_PARTNER_API: 'gst-partner-api',
        GST_LANGUAGE: 'gst-language',
        GST_TIMEZONE_OFFSET: 'gst-timezone-offset',
        GST_TIMEZONE: 'gst-timezone',
    },
    STATUS: {
        NOT_FOUND: 404,
        INTERNAL_SERVER_ERROR: 500,
    },
    FILTERS: {
        WITH_ENTITY: {
            ORDERS: 'ORDERS',
        },
    },
};
